import { FormControl, HStack, IconButton, Text, VStack } from 'native-base';

import { CommonInputWrapperProps } from './types';
import Icon from '../../Icon';

export const styles = {
  divIcon: {
    cursor: 'pointer',
    marginBottom: '5px',
  },
};

const CommonInputWrapper = (props: CommonInputWrapperProps) => {
  const {
    errorMessage,
    label,
    helpText,
    isRequired,
    children,
    helpIcon,
    helpIconColor,
    showHelpTextOnMobile = false,
    onHelpIconPress,
  } = props;

  return (
    <VStack w="100%">
      <HStack space={2} alignItems="center">
        {label && (
          <FormControl.Label margin={0}>
            {label}
            {isRequired ? <Text color="error.600">*</Text> : null}
          </FormControl.Label>
        )}
        {helpIcon && onHelpIconPress ? (
          <IconButton
            justifyContent="center"
            alignItems="center"
            onPress={onHelpIconPress}
            icon={<Icon color={helpIconColor} size={16} icon="help-circle" />}
            w="16px"
            h="16px"
            variant="unstyled"
            p={0}
            mb="10px"
          />
        ) : null}
      </HStack>

      <HStack
        flex={1}
        width="100%"
        alignContent="center"
        justifyContent="center"
        zIndex={9999}
      >
        {children}
      </HStack>

      {helpText && !errorMessage && (
        <Text
          mt={2}
          ml={2}
          display={{ base: showHelpTextOnMobile ? 'flex' : 'none', md: 'flex' }}
          fontWeight={400}
          fontSize="xs"
          color="muted.500"
        >
          {helpText}
        </Text>
      )}

      {errorMessage && (
        <Text fontWeight={400} fontSize="xs" color="error.500" mt="1" ml="2">
          {errorMessage}
        </Text>
      )}
    </VStack>
  );
};

export default CommonInputWrapper;
